import { cn } from "@omni/utils/styles";

import { useNewsletterContext } from "../../context/newsletter.context";

const TitleComponent = () => {
    const { alignment, helperText, isBold } = useNewsletterContext();
    return (
        <div
            className={cn(
                `h5 ${isBold ? "font-weight-bold" : ""} ${alignment} tw:mt-0!`
            )}
        >
            {helperText}
        </div>
    );
};

export { TitleComponent };
